module.exports = __webpack_public_path__ + "static/community-young-leader-photo@2x-72b1ebacbd19fe90ce4398ba3916e19d.jpg";